// on the 16/02/21, expiry dates were changed from 15days to 30days for documents in the backend
export const DOCUMENT_EXPIRE_DAYS_CHANGE = '02/16/21';
